import React from "react";
import { ManageCoupon } from "../../components/Settings/Coupon/ManageCoupon";
import { ToastContainer } from "react-toastify";
export const ManageCouponCodePage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ManageCoupon />
        </div>
      </div>
    </div>
  );
};
